// composables/usePowerBiData.ts
import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function usePowerBiData(companyId?: number) {
    const {
        data: powerBiData,
        isPending: isPowerBiPending,
        isFetching: isPowerBiFetching,
        isSuccess: isPowerBiSuccess,
        isError: isPowerBiDataError,
        error: powerBiDataError,
    } = useQuery({
        queryKey: [QueryKey.POWER_BI_DATA, companyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.powerbi.get'), {
                params: {
                    company_id: companyId,
                },
            });
            return data;
        },
        placeholderData: [],
        retry: false,
        refetchOnWindowFocus: false,
        gcTime: 0,
    });

    return {
        powerBiData,
        isPowerBiPending,
        isPowerBiFetching,
        isPowerBiSuccess,
        isPowerBiDataError,
        powerBiDataError,
    };
}
